import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {deleteShipmentFile} from "../../../../../api/order/OrdersApi";
import {OrdersShipmentDeliveryConfirmFileType} from "../interface";


export const useDeleteShipmentFile = () => {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation()
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: OrdersShipmentDeliveryConfirmFileType) => deleteShipmentFile(data),
        onSuccess: (res: any) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "삭제되었습니다",
                    type: "alert",
                    closeAction: () => {
                        qc.invalidateQueries({queryKey: ["readShipmentDeliveryConfirm"]})
                    }
                });
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.message ?? res.data.msg,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
